/**
 * Przekształca cenę w groszach (priceCents) na sformatowany ciąg PLN.
 * Przykłady:
 *   15000 -> "150,00 zł"
 *   0 -> "0,00 zł"
 *   5500 -> "55,00 zł"
 *   null / undefined -> "Brak wyceny"
 */
export function formatPricePLN(priceCents?: number | null, emptyText: string = 'Brak wyceny'): string {
  if (priceCents == null || isNaN(priceCents)) {
    return emptyText;
  }
  const pln = (priceCents / 100).toFixed(2);
  return `${pln.replace('.', ',')} zł`;
}

/**
 * Przekształca wpisaną przez użytkownika kwotę PLN (np. "150", "150,50", "150.50 zł", "200 PLN") na grosze.
 * Zwraca 0 dla niepoprawnej lub pustej wartości.
 */
export function parsePLNToCents(plnText?: string | number | null): number {
  if (plnText == null) {
    return 0;
  }
  if (typeof plnText === 'number') {
    return isNaN(plnText) || plnText < 0 ? 0 : Math.round(plnText);
  }
  if (typeof plnText !== 'string' || plnText.trim().length === 0) {
    return 0;
  }
  const cleanText = plnText
    .replace(/zł/gi, '')
    .replace(/pln/gi, '')
    .replace(/\s/g, '')
    .replace(',', '.');

  const parsedFloat = parseFloat(cleanText);
  if (isNaN(parsedFloat) || parsedFloat < 0) {
    return 0;
  }
  return Math.round(parsedFloat * 100);
}

/**
 * Formatuje timestamp (number w ms) lub ISO string do czytelnej daty: DD.MM.YYYY HH:mm lub - dla null/undefined.
 */
export function formatDate(timestamp?: number | string | null): string {
  if (!timestamp) {
    return '-';
  }
  const dateObj = typeof timestamp === 'number' ? new Date(timestamp) : new Date(timestamp);
  const timeMs = dateObj.getTime();
  if (isNaN(timeMs) || timeMs <= 0) {
    return '-';
  }
  const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
  const day = pad(dateObj.getDate());
  const month = pad(dateObj.getMonth() + 1);
  const year = dateObj.getFullYear();
  const hours = pad(dateObj.getHours());
  const minutes = pad(dateObj.getMinutes());

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}
